// src/pages/account/PrivacyPage.jsx
import DataPrivacyPanel from "./DataPrivacyPanel";
export default function PrivacyPage() {
  return <DataPrivacyPanel />;
}